import damp from "./math/damp.js";
function scrollTo(selectorElement, { offset = 0, dampFactor = 0.2 } = {}) {
  let targetElement = null;
  if (selectorElement instanceof HTMLElement) {
    targetElement = selectorElement;
  } else {
    targetElement = document.querySelector(selectorElement);
  }
  if (!targetElement) {
    return Promise.resolve(window.pageYOffset);
  }
  const sizes = targetElement.getBoundingClientRect();
  const scrollMargin = getComputedStyle(targetElement).scrollMarginTop || "0";
  const max = document.documentElement.scrollHeight - window.innerHeight;
  let scrollTarget = sizes.top + window.pageYOffset - Number.parseInt(scrollMargin, 10) - offset;
  if (scrollTarget > max) {
    scrollTarget = max;
  }
  return new Promise((resolve) => {
    let isScrolling = false;
    let scroll = window.pageYOffset;
    let dampScroll = window.pageYOffset;
    function eventHandler() {
      isScrolling = false;
    }
    function end() {
      window.removeEventListener("wheel", eventHandler);
      window.removeEventListener("touchmove", eventHandler);
      resolve(window.pageYOffset);
    }
    function loop() {
      if (!isScrolling) {
        return end();
      }
      dampScroll = damp(scroll, dampScroll, dampFactor);
      window.scrollTo({ top: dampScroll });
      if (dampScroll === scroll) {
        isScrolling = false;
      }
      return requestAnimationFrame(loop);
    }
    function start(target) {
      isScrolling = true;
      dampScroll = window.pageYOffset;
      scroll = target;
      window.addEventListener("wheel", eventHandler, { passive: true });
      window.addEventListener("touchmove", eventHandler, { passive: true });
      loop();
    }
    start(scrollTarget);
  });
}
export {
  scrollTo as default
};
//# sourceMappingURL=scrollTo.js.map
